var exports = {
  "Kk": "FeedCategoryIcon.module__icon___VDU3NW",
  "Vq": "FeedCategoryIcon.module__glyph___VDU3NW",
  "Vs": "FeedCategoryIcon.module__tile___VDU3NW",
};

module.exports = exports;
